import { StyledTextField } from '.';
import { Autocomplete, Box } from '@mui/material';

interface AutoCompleteInputProps {
    value?: number[];
    options: { id: number; name: string }[];
    onChange?: (newValue: number[]) => void;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    [key: string]: unknown;
}

const AutoCompleteInput = ({
    value = [],
    options,
    onChange = () => null,
    placeholder = 'Select options',
    disabled = false,
    error,
    onBlur = () => null,
    ...props
}: AutoCompleteInputProps) => {
    return <Box>
        <Autocomplete
            multiple
            options={options}
            getOptionLabel={(option) => option.name}
            value={options.filter((option) => (value as number[]).includes(option.id))}
            onChange={(event, newValue) => onChange(newValue.map((item) => item.id))}
            isOptionEqualToValue={(option, optionValue) => option.id === optionValue.id}
            renderInput={(params) => (
                <StyledTextField {...params} variant="outlined" error={error} onBlur={onBlur} placeholder={placeholder} />
            )}
            disabled={disabled}
            {...props}
        />
    </Box>;
};

export default AutoCompleteInput;